import { dimensionsKeys } from "../../../../utils";
import { FormLabel, GridItem } from "@chakra-ui/react";

function DimensionsGridHeaderRow({ organizationStructure, scope, consumptionTypesAttr, permanentColumns, isPreview }) {
  const headerTitles = [];

  dimensionsKeys.forEach(dimKey => {
    if (organizationStructure.dimensions[dimKey]) {
      headerTitles.push(organizationStructure.dimensions[dimKey].name);
    }
  });

  headerTitles.push(...permanentColumns);

  return headerTitles.map(headerTitle => {
    return <GridItem
      key={`heading-${headerTitle}-${scope === "one" ? consumptionTypesAttr : ""}`}
      borderWidth={"1px"}
      pl="4" pr="4" pt="2" pb="2"
      display="flex"
      alignItems="center"
      colSpan={isPreview ? 2 : headerTitle !== "" ? 2 : 1}
    >
      <FormLabel
        width="100%"
        opacity="0.75"
        fontSize="sm"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        margin="0"
        color={"esg_gray.400"}
        title={typeof headerTitle === "string" ? headerTitle : ""}
      >
        {headerTitle}
      </FormLabel>
    </GridItem>;
  });
}

export default DimensionsGridHeaderRow;